import React, { Component } from 'react';

import fileextension from 'file-extension'
import DocumentView from '../../document-view/DocumentView'
import VersionPdfViewContainer from '../../pdf-view/VersionPdfViewContainer'
import VideoView from '../../assets-view/VideoView'
import { SVGView } from '../../assets-view/SVGView'
import Viewer from 'react-viewer'
import { AUDIO_EXT } from '../../../utils'
import AudioView from '../../assets-view/AudioView'
import "./compare-versions.css"
import {

  handleSetSrc,

} from '../../../utils/index'
class CompareVersions2 extends Component {


  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const {
      itemsVersionsForCompare,
      itemSelected,
      viewerCompare,
      workclient
    }
      = this.props

    const assestToCompare = itemsVersionsForCompare
      .map((item) => {
        if (item === itemSelected.document._id.toString())
          return {
            src: itemSelected.document.originalURL,
            type: itemSelected.document.type,
            document: itemSelected.document,
            isCurrentVersion: true
          }
        else {
          const file = itemSelected.versions.find(
            (v) => v._id.toString() === item
          )
          if (file)
            return {
              src: file.document.originalURL,
              type: file.document.type,
              document: file.document,
              versionId: file._id,
              isCurrentVersion: false
            }
          else
            return {
              src: '/images/image-default.png',
              type: 'image',
            }
        }
      })


    return (
      <React.Fragment>

        <div className='compare-versions flex-style'>
          {
            assestToCompare.map((item, k) => {

              return (
                <React.Fragment key={`compare_version-${item.document.uuid}`}>
                  <div className="box" >

                    {item.type === 'image' && (
                      <React.Fragment>
                        <Viewer
                          visible={viewerCompare.show}
                          zoomable={true}
                          onClose={() =>
                            this.showViewerCompareVersion(false)
                          }
                          // showTotal={false}
                          changeable={false}
                          images={[{ src: viewerCompare.src, alt: '' }]}
                        />


                        {item.document.type === 'image' && fileextension(item.document.originalURL) === 'svg'
                          ? <div className='svg-box-main-versions'><SVGView comFromMiddleView={true} src={item.document.originalURL} /></div>
                          : item.document.type === 'image' &&
                            fileextension(item.document.originalURL) !== 'png' ? (
                            <img
                              alt={item.document.name}
                              src={handleSetSrc(item.document)}
                            />
                          ) : (
                            item.document.type === 'image' && (
                              <img
                                alt={item.document.name}
                                src={item.document.mediaQualityURL}
                              />
                            )
                          )}
                      </React.Fragment>
                    )}
                    {item.type === 'document' &&
                      AUDIO_EXT.includes(
                        fileextension(item.document.originalURL)
                      ) && (
                        <div style={{ padding: '25px' }}>
                          <AudioView
                            item={item.document}
                            from={`middleView`}
                            canCommentsAndVersions={true}
                          />
                        </div>
                      )}
                    {item.document.type === 'document' &&
                      !AUDIO_EXT.includes(
                        fileextension(
                          item.document.originalURL
                        )
                      ) && fileextension(
                        item.document.originalURL
                      ) !== 'pdf' ? (
                      <DocumentView
                        item={item.document}
                        from={`middleView`}
                      />
                    ) : (
                      fileextension(
                        item.document.originalURL
                      ) === 'pdf' && item.document.documentPages &&
                        item.document.documentPages.length > 0 ?
                        <div className='version-pdf-wrapper'>
                          <VersionPdfViewContainer
                            itemSelected={item}
                            from={`middleView5`}
                            workclient={workclient}
                            isComparingVersion={true}
                          />
                        </div>
                        : fileextension(
                          itemSelected.document.originalURL
                        ) === 'pdf' &&
                        <DocumentView
                          item={itemSelected.document}
                          from={`middleView`}
                        />
                    )
                    }

                    {item.type === 'video' && (
                      <div
                        style={{
                          margin: '13px',
                          marginBottom: '1%',
                          width: '300px',
                        }}
                      >
                        <VideoView
                          url={item.src}
                          disableDefaultControls={false}
                          autoPlay={false}
                          muted={false}
                        />
                      </div>
                    )}
                  </div>

                </React.Fragment>

              )
            })
          }
        </div>
      </React.Fragment>
    )

  }

}
export default CompareVersions2